import { defineMessages } from 'react-intl';

export const customerReviewsInfoCallToActionMessages = defineMessages({
  title: {
    id: 'customerReviews.infoCallToAction.title',
    defaultMessage: 'Hinweise zu Bewertungen',
  },
  ariaLabel: {
    id: 'customerReviews.infoCallToAction.aria.label',
    defaultMessage: 'weitere Informationen zu Kundenbewertungen',
  },
});
